
                (function () {
                  function setup() {
                    const cursor = document.querySelector(
                      '.section-template--26147941450026__before_after_Umqyap .before-after__cursor'
                    );
                    const imageWrapper = document.querySelector(
                      '.section-template--26147941450026__before_after_Umqyap .before-after-image-wrapper'
                    );

                    // drag the cursor to update the imageWrapper's --clip-path-offset value (px)
                    let xStart, xEnd, xDiff, originalOffset;
                    function dragStart(event) {
                      xStart = event.clientX;
                      originalOffset = imageWrapper.style
                        .getPropertyValue('--clip-path-offset')
                        .slice(0, -2);
                      //xStart = imageWrapper.style
                      //  .getPropertyValue('--clip-path-offset')
                      //  .slice(0, -2);
                      document.addEventListener('pointermove', dragMove);
                      document.addEventListener('pointerup', dragEnd);
                    }

                    function dragMove(event) {
                      xEnd = event.clientX;
                      xDiff = xEnd - xStart;

                      // clamp the value to the imageWrapper's 1/2 width
                      let result = xDiff + parseInt(originalOffset);
                      let cursorOffsetPercent = parseFloat(getComputedStyle(imageWrapper).getPropertyValue('--before-after-initial-drag-position'));
                      let containerWidth = imageWrapper.offsetWidth;
                      let pixelsOffset = (cursorOffsetPercent / 100) * containerWidth;
                      
                      const negativeMax = -1 * (pixelsOffset);
                      const positiveMax = imageWrapper.offsetWidth - pixelsOffset;
                      if (result < negativeMax) {
                        result = negativeMax;
                      } else if (result > positiveMax) {
                        result = positiveMax;
                      }
                      imageWrapper.style.setProperty(
                        '--clip-path-offset',
                        result + 'px'
                      );
                    }

                    function dragEnd(event) {
                      document.removeEventListener('pointermove', dragMove);
                      document.removeEventListener('pointerup', dragEnd);
                    }

                    cursor.addEventListener('pointerdown', dragStart);
                  }
                  setup();
                  if (Shopify.designMode) {
                    document.addEventListener('shopify:section:load', setup);
                  }
                })();
              